export default __webpack_public_path__ + "static/media/6-2.b9865f47.png";